export const config = {
	mode: import.meta.env.DEV ? 'dev' : 'production',
	isDev: import.meta.env.DEV,
	isProd: import.meta.env.PROD,
} as const

// In dev, API_BASE is '/api' — Vite proxies it at the hewey-localdev API
// Gateway (LOCALDEV_API_URL in client/.env.local), which keeps the session
// cookie first-party on localhost. In prod, set VITE_API_BASE to the API
// Gateway origin (e.g. https://api.hewey.app).
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api'

export const APPS = [
	{ slug: 'todo', name: 'Todo', emoji: '✅', tint: 'sage' },
	{ slug: 'activities', name: 'Activities', emoji: '🎨', tint: 'lilac' },
	{ slug: 'meals', name: 'Meal planner', emoji: '🍲', tint: 'apricot' },
	{ slug: 'recipes', name: 'Recipes', emoji: '🥘', tint: 'terracotta' },
	{ slug: 'groceries', name: 'Groceries', emoji: '🛒', tint: 'sage' },
] as const

export type AppSlug = (typeof APPS)[number]['slug']
